import { getClassifyList } from '@/api/category'
import { shopClassifyList } from '@/api/sellerCategory'

const category = {
  state: {
    // token: localStorage.getItem('token')

  },

  mutations: {
    // SET_TOKEN: (state, token) => {
    //   state.token = token
    //   localStorage.setItem('token', token)
    // }
  },

  actions: {
    // 登录
    GetClassifyList ({ commit }, dataObj) {
      return new Promise((resolve, reject) => {
        getClassifyList(dataObj).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //店铺商品分类
    ShopClassifyList ({ commit }, dataObj) {
      return new Promise((resolve, reject) => {
        shopClassifyList(dataObj).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default category



// WEBPACK FOOTER //
// ./src/store/modules/category.js